import React, { useState } from 'react';
import { Form, Input, Button, Card, message, Row, Col } from 'antd';
import { SendOutlined, MailOutlined } from '@ant-design/icons';
import AccountHeader from './AccountHeader';
import { POST_SUPPORT_URL, post_data_token } from '../../config/network';
import { FormattedMessage } from 'react-intl';

const { TextArea } = Input;

const Support = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      await post_data_token(POST_SUPPORT_URL, {
        email: values.email,
        content: values.content,
      });
      
      message.success(
        (window.appLocale && window.appLocale.messages && window.appLocale.messages['page.support.submit.success']) || 
        'Submit successfully! We will reply you as soon as possible.'
      );
      form.resetFields();
    } catch (err) {
      message.error(
        (window.appLocale && window.appLocale.messages && window.appLocale.messages['page.user.support.submit.err']) || 
        `Submit error: ${err}`
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dashboard-container">
      <AccountHeader 
        page={"Support"} 
        title={<FormattedMessage id="page.sidnav.title.Support" defaultMessage="Support" />} 
      />
      
      <div className="dashboard-content">
        <Row justify="center">
          <Col xs={24} sm={20} md={16} lg={12}>
            <Card 
              title={
                <div style={{ textAlign: 'center' }}>
                  <MailOutlined style={{ marginRight: 8 }} />
                  <FormattedMessage id="page.support.title" defaultMessage="Contact Support" />
                </div>
              }
              bordered
              style={{ marginTop: 20 }}
            >
                <Form
                  form={form}
                  layout="vertical"
                  onFinish={handleSubmit}
                  size="large"
                >
                  <Form.Item
                    label={<FormattedMessage id="page.support.email" defaultMessage="Your Email" />}
                    name="email"
                    rules={[
                      {
                        required: true,
                        message: (window.appLocale && window.appLocale.messages && window.appLocale.messages['page.support.email.err']) || 'Please input your email'
                      },
                      {
                        type: 'email',
                        message: 'Please enter a valid email address'
                      }
                    ]}
                  >
                    <Input 
                      prefix={<MailOutlined />}
                      placeholder="Enter your email address"
                    />
                  </Form.Item>

                  <Form.Item
                    label={<FormattedMessage id="page.support.content" defaultMessage="Content" />}
                    name="content"
                    rules={[
                      {
                        required: true,
                        message: (window.appLocale && window.appLocale.messages && window.appLocale.messages['page.support.content.err']) || 'Please input content'
                      },
                      {
                        min: 10,
                        message: 'Content must be at least 10 characters long'
                      }
                    ]}
                  >
                    <TextArea
                      rows={6}
                      placeholder="Describe your issue or question in detail..."
                      showCount
                      maxLength={1000}
                    />
                  </Form.Item>

                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      loading={loading}
                      icon={<SendOutlined />}
                      block
                      size="large"
                    >
                      <FormattedMessage id="page.submit" defaultMessage="Submit" />
                    </Button>
                  </Form.Item>
                </Form>
              </Card>
            </Col>
          </Row>
        </div>
    </div>
  );
};

export default Support;
